/**
 * Created by manoraj.k on 17/08/17.
 */
import React from "react";
import styled from "styled-components";
import {colors} from "../../colorCodes";

export const SimpleSearchIcon = styled.span`
position:absolute;
right: 10px;
top: 50%;
-webkit-transform: translateY(-54%);
-ms-transform: translateY(-54%);
transform: translateY(-54%);
cursor : pointer;
&.active-icon-color {
        color : ${colors.brandBlue}
    }
    &.inprogress-icon-color {
        color : ${colors.inprogressIcon}
    }
`;